import { ComponentPropsWithoutRef, FC, ReactNode } from "react";

type ButtonProps = {
  label: ReactNode;
  variant: "primary" | "secondary";
  formButton?: boolean;
  faqButton?: boolean;
  isDisabled?: boolean;
} & ComponentPropsWithoutRef<"button">;

const Button: FC<ButtonProps> = ({ label, variant, formButton, faqButton, isDisabled, ...otherProps }) => {
  if (variant === "primary") {
    return (
      <p>
        <button className={`flex items-center justify-center gap-[8px] border border-[#E9E9E9] text-primaryDark-0 px-[24px] py-[12px] text-[14px] font-semibold font-raleway ${isDisabled ? "" : "hover:text-text-1000 hover:bg-primaryDark-400 transition-all"}  ${formButton ? "w-full" : ""} ${faqButton ? "rounded-[68px]" : "rounded-[8px]"}`} {...otherProps}>{label}</button>
      </p>
    );
  }

  return (
    <p>
      <button
        className={`flex items-center justify-center gap-[8px] bg-primaryDark-0 border border-primaryDark-0 px-[24px] py-[12px] text-[14px] text-text-1000 font-semibold font-raleway  ${isDisabled ? "" : "hover:border-primaryDark-400 hover:bg-primaryDark-400 transition-all"} ${formButton ? "w-full" : ""} ${faqButton ? "rounded-[68px]" : "rounded-[8px]"}`}
        {...otherProps}>
        {label}
      </button>
    </p>
  );
};

export default Button;